// IMPORTS
//-------------------------------------------------------------------------------------------------------------------------
//Angular
import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Params, Router } from '@angular/router';

//Services
import { CASNavBoxService } from '../../shared/components/cas-navbox/cas-navbox-service';
import { CPDFormatters } from '../../shared/services/cpd-formatters';
//import { FormDataService2 } from '../../shared/services/formData2';
import { Helpers } from '../../shared/services/helpers';
import { WebServices } from '../../shared/services/webServices';

//Libraries
import { BCGrowls } from '../../shared/library/bcGrowls';
import { CASValidate } from '../../shared/library/casValidate';

//Config/Globals
import { Enums } from '../../shared/enums.js';

//Token
import { authToken } from '../../shared/authToken';

//Classes
import { FormAction } from "../../shared/classes/formAction";



// EXPORTS
//-------------------------------------------------------------------------------------------------------------------------
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// CppeMainComponent
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
@Component({
    styles : ['.rcm-main-content-div{position:absolute;top:0;right:0;bottom:0;left:0px;display:flex;flex-direction:column;min-width:450px}.rcm-control-div{flex-grow:0;display:flex;flex-wrap:wrap;align-items:center;margin:0px 8px 8px 8px;padding:2px 0 2px 20px;background-color:#eee;border:solid 1px #b8b8b8;border-radius:4px}.rcm-control-div-alt-1{flex-grow:0;display:flex;flex-wrap:wrap;align-items:center;margin:0px 8px 8px 8px;padding:2px 0 2px 20px;background-color:#eef;border:solid 1px #b8b8b8;border-radius:4px}.rcm-control-div-alt-2{display:flex;align-items:center;margin:0px 0 8px 8px;padding-left:20px;font-size:12px}.rcm-land_use-control-div{flex-grow:0;display:flex;flex-wrap:wrap;align-items:center;margin:0 8px 10px 8px;padding:0 8px;background-color:#eee;border:solid 1px #ddd;border-radius:4px}.rcm-filter-radio{padding-left:10px;display:flex;align-items:center}.rcm-resource-grid-div{flex-grow:1;position:relative;margin-top:15px;border-top:solid 1px #b8b8b8}.rm-ui-field{width:90%;margin-left:10px;color:#666}.rm-ui-field-div{margin:0 0 15px 0}.rm-ui-flex-field-div{margin:0 0 0 0;display:flex;align-items:center}.rm-ui-flex-field-lbl{white-space:nowrap;flex-wrap:nowrap;margin-right:0px}.rm-ui-dates-block{display:flex}.rm-ui-checks-block{display:flex}.rm-ui-popup-edit-resource{width:625px;max-width:625px}.rm-ui-popup-export{width:500px;max-width:500px}.rm-cssClasses_Grid{border-bottom:none !important}.rm-cssClasses_ColumnHeaderRow{height:10px;font-size:1px;font-weight:normal !important;box-shadow:none !important;border-top:none !important;text-align:left;width:180px;padding:0}.rm-cssClasses_Body{border:solid 1px #b8b8b8;border-radius:2px;background-color:#f0f0f0}.rm-cssClasses_Cell{padding:0 2px !important}'],
    template : '<!--Content Div-->\n<div class="rcm-main-content-div" data-test-id="content_component_land_use">\n\n    <!-- ---------------------------------------------------- -->\n    <!-- Title -->\n    <!-- ---------------------------------------------------- -->\n    <h2 tabindex="-1" class="cpd-title-div">{{_title}}</h2>\n    <div class="cpd-subtitle-div">Select a land use to edit its association to the component.</div>\n\n    <!--Content Loading -->\n    <div *ngIf="casNavBoxService.ActionsLoading || _pageLoading" class="cpd-ui-content-loading">\n        <img src="public/cpd-images/loading.gif" />\n        <div style="margin-left:10px;">Loading...</div>\n    </div>\n\n    <!--CONTENT CONTAINER (hidden during loading operations)-->\n    <ng-container *ngIf="!_pageLoading">\n\n        <!-- ---------------------------------------------------- -->\n        <!-- Control Div -->\n        <!-- ---------------------------------------------------- -->\n\n        <div class="rcm-land_use-control-div">\n            \n            <!--Component-->\n            <div class="cpd-control-unit" style="width:100%;">\n                <label>Component: {{_resourceComponentName}}</label>\n            </div>              \n\n            <!--FISCAL YEAR-->\n            <div class="cpd-control-unit">\n                <label for="selFY" class="cpd-ui-field-div-lbl">Fiscal Year</label>\n                <select id="selFY" [disabled]="_disableControls" [(ngModel)]="_selectedFY" (change)="fiscalYearChanged($event)">\n                    <option *ngFor="let fy of _fiscalYears;" [ngValue]="fy">{{fy}}</option>\n                </select>\n                <div style="width:20px;"></div>\n            </div>\n\n            <!--Date Range-->\n            <div class="cpd-control-unit">\n                <label *ngIf="_fiscalStart" class="cpd-ui-field-div-lbl">Start Date: {{_fiscalStart | date}}</label>\n                <label *ngIf="!_fiscalStart" class="cpd-ui-field-div-lbl">Start Date: --</label>\n                <div style="width:20px;"></div>\n            </div>\n            <div class="cpd-control-unit">\n                <label *ngIf="_fiscalEnd" class="cpd-ui-field-div-lbl">End Date: {{_fiscalEnd | date}}</label>\n                <label *ngIf="!_fiscalEnd" class="cpd-ui-field-div-lbl">End Date: --</label>\n                <div style="width:20px;"></div>\n            </div>\n\n            <!--GO BUTTON -->\n            <div class="cpd-control-unit">\n                <button type="button" class="btn btn-primary" [disabled]="!_goButtonOn || _disableControls" (click)="goButtonClicked()">GO</button>\n            </div>               \n\n        </div>\n\n        <!-- ---------------------------------------------------- -->\n        <!-- Grid Div -->\n        <!-- ---------------------------------------------------- -->\n        <div class="rcm-resource-grid-div">\n            <cas-grid #mainGrid\n                      summary="Land Use List"\n                      [settings]="_mainGridSettings"\n                      (onRowSelectionChanged)="gridRowSelected()"\n                      (onRefreshClicked)="gridRefreshClicked()"\n                      (onSearch)="onGridSearch($event)">\n            </cas-grid>\n        </div>\n\n    </ng-container>\n\n    <!--POPUP INSTANCE CONTAINER-->\n    <!--When the Modal component inserts the Angular component that wraps the Bootstrap popups, it needs to go somewhere\n    where it will be cleared when the user navigates away from this page.  Note that the popup elements inserted here\n    are moved to the \'body\' when displayed and then moved back here when not (so the heat shield/backdrop is under them in z-order).-->\n    <div id="component_land_use_page_popups"></div>\n\n    <!--========================================-->\n    <!-- Land Use Popup -->\n    <!--========================================-->\n    <modal #popLandUse\n           containerId="component_land_use_page_popups"\n           title={{_popupTitle}}\n           label="popLandUse"\n           customClass="rm-ui-popup-export">\n\n\n        <!--FVT-ID-->\n        <section name="fvt_id" style="visibility:hidden;" data-test-id="dialog_land_use"></section>\n\n        <!-- body -->\n        <section>\n\n            <!--For 508-->\n            <div style="position:relative; top:-8px; left:5px; font-style:italic;"><br /></div>\n\n            <!--Single Row display-->\n            <div id="popupLandUseFields" class="cpd-ui-row">\n\n                <!--Single Cell display-->\n                <div class="cpd-ui-cell" style="flex-grow:1;">\n\n                    <!--Heading-->\n                    <div *ngIf="_newLandUse" class="cpd-ui-group-lbl" role="heading" aria-level="5" title="Add Land Use to Resource Concern Component" attr.aria-label="Add Land Use to Resource Concern Component">\n                        <h3>Land Use Association</h3>\n                    </div>\n                    <div *ngIf="!_newLandUse" class="cpd-ui-group-lbl" role="heading" aria-level="5" title="Edit Land Use to Resource Concern Component" attr.aria-label="Edit Land Use to Resource Concern Component">\n                        <h3>Land Use Association</h3>\n                    </div>\n\n                    <div style="margin:20px 0;"></div>\n\n                    <!--Land Use-->\n                    <div class="cpd-ui-field-div" style="margin:10px 0 10px 5px;">\n                        <label for="popupLandUse_selLandUse" style="width:60px; text-align:left;" class="cpd-ui-field-div-lbl">Land Use:</label>\n                        <label *ngIf="!_newLandUse" for="popLandUse_txtLandUse" class="rm-ui-flex-field-lbl">\n                            {{_landUseName}}\n                        </label>\n                        <select *ngIf="_newLandUse" id="popupLandUse_selLandUse" style="max-width:255px; min-width:255px;"\n                                (change)="_formChanged(\'popLandUse_body\')"\n                                [(ngModel)]="_selectedLandUses_LandUsePopup"\n                                class="cval"\n                                data-cval-msg-element-id="selectedLandUses_vmsg"\n                                data-cval-fld-name="Land Use"\n                                data-cval-dropdown-selected="true">\n                            <option *ngFor="let landUse of _allLandUses;" [ngValue]="landUse">{{landUse.land_use_display}}</option>\n                        </select>\n                    </div>\n                    <!--Land Uses validation message-->\n                    <div *ngIf="_newLandUse" id="selectedLandUses_vmsg" class="cval-validation-message" style="padding-left:10px;padding-bottom:3px;"></div>\n\n\n                    <!--Resource Component - Dates Block-->\n                    <div class="rm-ui-dates-block">\n\n                        <!--Start Date-->\n                        <div class="rm-ui-flex-field-div" style="margin-left:5px;">\n                            <label for="popLandUse_txtStartDate" class="rm-ui-flex-field-lbl">\n                                <span aria-label="required" style="color:red;">*</span>\n                                Start Date:&nbsp;\n                            </label>\n                            <div class="cpd-ui-field-div">\n                                <input type="date"\n                                       [min]="_today"\n                                       placeholder="m/d/yyyy"\n                                       id="start_date" name="startDate"\n                                       data-cval-msg-element-id="start_date_vmsg"\n                                       data-cval-fld-name="Start Date"\n                                       [attr.data-cval-required]="true"\n                                       [attr.data-cval-date]="true"\n                                       [attr.readonly]="(_publishOriginal && _startDatePassed) ? \'readonly\' : null"\n                                       style="width:140px;"\n                                       aria-label="Start date (format m/d/yyyy)"\n                                       (input)="_popupDirty = true;"\n                                       class="cval form-control"\n                                       [ngModel]="_startDate"\n                                       (ngModelChange)="_startDate=$event; _formChanged(\'popLandUse_body\')" />\n\n                            </div>\n                        </div>\n\n                        <!--Spacer-->\n                        <div style="width:20px;"></div>\n\n                        <!--End Date-->\n                        <div class="rm-ui-flex-field-div" style="margin-left:5px;">\n                            <label for="popLandUse_txtEndDate" class="rm-ui-flex-field-lbl">End Date:&nbsp;</label>\n                            <div class="cpd-ui-field-div">\n                                <input type="date"\n                                       [min]="_today"\n                                       placeholder="m/d/yyyy"\n                                       id="end_date" name="endDate"\n                                       data-cval-msg-element-id="end_date_vmsg"\n                                       data-cval-fld-name="End Date"\n                                       [attr.data-cval-required]="false"\n                                       [attr.data-cval-date]="true"\n                                       style="width:140px;"\n                                       aria-label="End date (format m/d/yyyy)"\n                                       (input)="_popupDirty = true;"\n                                       class="cval form-control"\n                                       [ngModel]="_endDate"\n                                       (ngModelChange)="_endDate=$event; _formChanged(\'popLandUse_body\')" />\n\n                            </div>\n                        </div>\n\n                    </div>\n\n                    <!--Component Start Date validation message-->\n                    <div id="start_date_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n                    <div id="end_date_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n\n\n                    <div style="border-top:solid 1px #ccc; margin:5px 0;"></div>\n\n                    <!--Checkbox Block-->\n                    <div class="rm-ui-checks-block" style="padding:3px 0 3px 0;">\n\n                        <!--Publish-->\n                        <div class="rm-ui-flex-field-div" style="margin-left:5px;">\n                            <label for="popLandUse_chkPublish" class="rm-ui-flex-field-lbl">Publish:&nbsp;</label>\n                            <input *ngIf="_publishOriginal"\n                                   aria-disabled="true"\n                                   aria-label="Publish checkbox"\n                                   type="checkbox"\n                                   onclick="return false"\n                                   role="application"\n                                   id="popLandUse_chkPublish"\n                                   name="popLandUse_chkPublish"\n                                   [(ngModel)]="_publish"/>\n                            <input *ngIf="!_publishOriginal" tabindex="0" type="checkbox"\n                                   id="popLandUse_chkPublish"\n                                   name="popLandUse_chkPublish"\n                                   [(ngModel)]="_publish"\n                                   (click)="_popupDirty = true;"\n                                   (input)="_popupDirty = true;" />\n                        </div>\n\n                    </div>\n                </div><!--End Cell-->\n            </div><!--End Row-->\n\n        </section>\n\n        <!-- footer -->\n        \n        <footer>\n            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>\n            <button type="button" class="btn btn-primary" accesskey="s" (click)="saveLandUse()"><u>S</u>ave</button>\n        </footer>\n\n    </modal>\n\n</div>\n',
    providers: [],
    encapsulation: ViewEncapsulation.None //Allows child components to read the parent's styles
})
export class ResourceComponentLandUseComponent implements OnInit {

    // INPUTS/OUTPUTS/COMPONENTS
    //-------------------------------------------------------------------------------------------------------------------------
    @ViewChild('mainGrid') mainGrid;
    @ViewChild('popLandUse') popLandUse;

    //Class wide member reference for the growls control
    growlBox = null;

    // PRIVATE MEMBERS
    //-------------------------------------------------------------------------------------------------------------------------
    _authToken = authToken; //authToken sometimes acts weird sometimes if you don't assign it locally

    //Boiler Plate
    _componentName = 'resourceComponentLandUse.js';
    _disableControls = false;
    _disposalFunctions = []; //For disposing subscriptions to rxjs observables
    _formName = 'landUse'; //Just a shortcut (also helpful for cut & paste)
    _pageLoading = true;
    _title = "Component Land Uses";
    _popupTitle = "Add Land Use to Component";
    _today = new Date().toISOString().substring(0, 10);

    //Data
    _componentId = 0;
    _resourceComponentName = "";
    _fiscalYears = [];
    _fiscalStart = '';
    _fiscalEnd = '';
    _landUseName = "";
    _newLandUse = true;
    _allLandUses = [];
    _selectedFY;
    _selectedLandUse = null;
    _selectedRow = null;
    _startDate = "";
    _startDatePassed = false;
    _endDate = "";
    _publish = false;
    _publishOriginal = false;
    _resourceConcernComponentLandUseId = 0;
    _selectedLandUses_LandUsePopup = this._allLandUses[0];

    _insertLU = {
        resource_concern_component_land_use_id: 0,
        start_date: "",
        end_date: "",
        publish: false
    }
    _updateLU = {
        resource_concern_component_id: 0,
        land_use_id: 0,
        start_date: "",
        end_date: "",
        publish: false
    }


    //UI Indicators
    _goButtonOn = false;

    //Popup
    _popupDirty = false;
    _popupValid = true;

    //Main Grid
    _mainGridSettings = {
        hideClearSelectedButton: true,
        loading: false,
        hideSearchBox: false,
        positionAbsolute: true,
        rows: [],
        rowIdentifyForJAWS: true,
        rowIdentityFieldForJAWS: "land_use_name",
        rowIdentityPrefixForJAWS: "Land Use",
        columns: [
            { fieldName: 'land_use_display', display: 'Land Use', width: '40%', minWidth: 30 },
            { fieldName: 'start_date', display: 'Start Date', width: '15%', minWidth: 100, procDataFn: (start_date, row) => { return this.cpdFormatters.formatDateString(start_date); }, },
            { fieldName: 'end_date', display: 'End Date', width: '15%', minWidth: 50, procDataFn: (end_date, row) => { return this.cpdFormatters.formatDateString(end_date); }, },
            { fieldName: 'publish', display: 'Published', width: '10%', minWidth: 50 }
        ]
    };


    // INITIALIZATION
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // constructor
    //==================================
    constructor(
        casNavBoxService: CASNavBoxService,
        cpdFormatters: CPDFormatters,
        domSanitizer: DomSanitizer,
        //formDataService: FormDataService2,
        helpers: Helpers,
        route: ActivatedRoute,
        router: Router,
        webServices: WebServices) {

        this.constructor.mapParams(this, arguments);

        //Handle clicks on the NavBox actions via the navBoxCommService
        let disposer = casNavBoxService.OnActionClicked$.subscribe(action => {
            this.navBoxActionClicked(action);
        });
        this._disposalFunctions.push(disposer);

        // Validation
        //--------------
        this.casValidate = new CASValidate();

        // Debugging 
        //--------------
        casNavBoxService.ClearDebugEntries();
        casNavBoxService.DebugEntries.push("Navigate to Edit");

        this._disableControls = false;
    };

    //==================================
    // ngOnDestroy
    //==================================
    ngOnDestroy() {
        for (var i = 0; i < this._disposalFunctions.length; i++) {
            this._disposalFunctions[i].unsubscribe();
        }
    };

    //==================================
    // ngOnInit
    //==================================
    ngOnInit() {

        console.log("\n[{0}:ngOnInit()]------------------------------------------------------------------------".format(this._componentName));

        this.initalizeGrowlBox();

        this.casNavBoxService.ActionsLoading = true;

        //508
        window.setTimeout(() => {
            document.getElementById("accAlertAssertive").innerText = "Loading page data";
            let el = document.getElementsByClassName("cpd-title-div")[0];
            if (el) { el.focus(); }
        }, 0);

        // PARAMS
        this._componentId = this.route.snapshot.params.componentId;
        this._selectedFY = this.route.snapshot.params.fy;

        this.loadActionLinks();

        //Async ops
        let ops = 2;

        //FISCAL YEARS
        this.initFiscalYears(() => {
            if (--ops == 0) { this.ngOnInit_Complete(); }
        });

        //LAND USES 
        this.initLandUseGrid(() => {
            if (--ops == 0) { this.ngOnInit_Complete(); }
        });

    };

    //=======================================
    // ngOnInit_Complete
    //=======================================
    // Called once all the async work in onInit is complete
    ngOnInit_Complete() {

        //Init the validation class
        this.casValidate.initialize(true);
        this._goButtonOn = true;
        this._pageLoading = false;
        this.casNavBoxService.ActionsLoading = false;
    };

    //========================================
    // initalizeGrowlBox
    //========================================
    initalizeGrowlBox() {
        this.growlBox = new BCGrowls("growlBox");
        this.growlBox.init({
            appendToElementId: "cpdesGrowlContainer" //cpdesGrowlContainer defined in \Nrcs.Cpdes.Ui\src\cpdes\components\cpdes.html
        });
    }


    // SERVICE - EVENT HANDLERS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // navBoxActionClicked
    //==================================
    navBoxActionClicked(action) {
        if (!action || !action.field_name) { return; }

        switch (action.field_name.toLowerCase()) {

            case "act_back_to_component":
                let routeV2 = "/cpdes/practices/resource";
                this.router.navigate([routeV2]);
                break;

            case "act_delete_land_use":
                if (!this._selectedRow) {
                    this.growlBox.addGrowl("info", "Please select an unpublished row to delete");
                    return;
                }
                if (this._selectedRow.publish.toUpperCase() == "Y") {
                    this.growlBox.addGrowl("warn", "Published Land Uses cannot be deleted");
                }
                else {
                    this.action_deleteLandUse();
                }
                break;

            case "act_new_land_use":
                this.action_addLandUse();
                break;

            case "act_edit_land_use":
                if (!this._selectedRow) {
                    this.growlBox.addGrowl("info", "Please select a row to edit");
                    return;
                }

                this.action_editLandUse();
                break;

        }
    };


    // UI - EVENT HANDLERS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // fiscalYearChanged
    //==================================
    fiscalYearChanged(e) {

        //Clear the grid as the data here is not invalid and could be confusing when someone opens the edit 
        //popup which will have the new fy data displayed.
        this.mainGrid.ClearRows();
        this._selectedRow = null;

        //Clear any search box filters
        this.mainGrid.ClearFilter("search", false);
        this.mainGrid.ClearSearchBox();

        //Get fiscal year date range
        this.getFiscalYearDateRange((dateRange) => {
            this._fiscalStart = dateRange.start;
            this._fiscalEnd = dateRange.end;
        });
    };

    //==================================
    // _formChanged
    //==================================
    _formChanged(modelName, event) {
        //Mark the form dirty if it isn't already
        if (!this._popupDirty) {
            this._popupDirty = true;
        }

        //Check the popup's validity
        let isValid = this.casValidate.isAllValid(true, modelName);
        if (isValid) {
            this._popupValid = true;
        }
        else {
            //Form is invalid
            this._popupValid = false;
        }
    };

    //==================================
    // goButtonClicked
    //==================================
    //  callback<fn>:       //(opt,null)
    goButtonClicked(fnOnComplete) {

        this._goButtonOn = false;
        this.mainGrid.MarkAsLoading(true);

        //Clear any search box filters
        this.mainGrid.ClearFilter("search", false);
        this.mainGrid.ClearSearchBox();

        let fy = this._selectedFY || null;

        //Load the filtered land uses
        this.loadComponentLandUses(fy, this._componentId, (dto) => {

            //Update the grid to show the land uses (grid should be loaded by the time GO can be clicked)
            this.mainGrid.SetRows(dto);

            //Clean up UI load indicators
            this.mainGrid.MarkAsLoading(false);
            this._goButtonOn = true;

            if (this.helpers.isFunction(fnOnComplete)) { fnOnComplete(); }
        });
    }

    //==================================
    // gridRefreshClicked
    //==================================
    gridRefreshClicked() {
        this.resetSelectedFiscalYear();
        //this.updateSessionStorage();

        // Refresh grid
        this.goButtonClicked();
    }

    //==================================
    // gridRowSelected 
    //==================================
    gridRowSelected(row) {
        //This is called when a row is selected AND unselected, resulting in a "null" selected row when unselected
        this._selectedRow = this.mainGrid.GetFirstSelectedRow(); //There will only be one for this single-select grid
        //console.log("  [{0}:gridRowSelected()] row:".format(this._componentName), this._selectedRow);
    }

    //==================================
    //  onGridSearch
    //==================================
    onGridSearch(searchText) {

        //console.log("onGridSearch", event);

        //This is for readability
        let searchFilterName = "search";
        let applyImmediately = true;

        //If the search box is empty, clear the filter
        if (!searchText || searchText.length == 0) {
            this.mainGrid.ClearFilter(searchFilterName, applyImmediately);
            this.sendJawsNotification("The list has updated");
            return;
        }

        //Create the filter function
        let fnFilter = (row) => {
            return row.land_use_name.toLowerCase().indexOf(searchText) >= 0 || row.land_use_name.toLowerCase().indexOf(searchText) >= 0;
        };

        //Set the "search" filter on the grid
        this.mainGrid.SetFilter(searchFilterName, fnFilter, applyImmediately);
        this.sendJawsNotification("The list has updated");
    }


    // BUSINESS LOGIC & NON-UI EVENT HANDLERS
    //-------------------------------------------------------------------------------------------------------------------------
    //=======================================
    // action_addLandUse
    //=======================================
    action_addLandUse() {
        //prep the popup with null values
        this._newLandUse = true;
        this._popupTitle = "Add Land Use to Component";
        this._publish = false;
        this._publishOriginal = false;
        this._landUseName = "";
        this._startDate = "";
        this._endDate = "";
        this._startDatePassed = this._startDate < this._today;

        this.loadAllLandUses(() => {
            this._selectedLandUses_LandUsePopup = this._allLandUses[0];
        });

        //Open the popup
        this.popLandUse.Open();

    }

    //=======================================
    // action_deleteLandUse
    //=======================================
    action_deleteLandUse() {

        this._resourceConcernComponentLandUseId = this.mainGrid.GetFirstSelectedRow().resource_concern_component_land_use_id;

        this.deleteLandUse();
    }

    //=======================================
    // action_editLandUse
    //=======================================
    action_editLandUse() {
        //prep the popup with selected values
        this._newLandUse = false;
        this._popupTitle = "Edit Land Use Association";
        this._selectedLandUse = this.mainGrid.GetFirstSelectedRow();
        this._resourceConcernComponentLandUseId = this._selectedLandUse.resource_concern_component_land_use_id;
        this._publishOriginal = this._selectedLandUse.publish.toUpperCase() == 'Y' ? true : false;
        this._publish = this._selectedLandUse.publish.toUpperCase() == 'Y' ? true : false;
        this._landUseName = this._selectedLandUse.land_use_display;
        this._startDate = this._selectedLandUse.start_date ? new Date(this._selectedLandUse.start_date).toISOString().substring(0, 10) : null;
        this._endDate = this._selectedLandUse.end_date ? new Date(this._selectedLandUse.end_date).toISOString().substring(0, 10) : null;
        this._startDatePassed = this._startDate < this._today;

        //Open the popup
        this.popLandUse.Open();

    }

    //=======================================
    // deleteLandUse
    //=======================================
    deleteLandUse() {

        //Notify saving to the user
        this.markGridAsLoading(true);
        this.growlBox.addGrowl("info", "Deleting Land Use...");

        //Do the deed
        this.webServices.Post("/landuse/deleteRCCLU", this._resourceConcernComponentLandUseId)
            .then(res => {
                console.log("[{0}:/landuse/deleteRCCLU()] - res:".format(this._componentName), res);

                if (res.Success) {

                    //Update the alerts & refresh grid
                    this.growlBox.addGrowl("success", "Land Use Deleted");
                    this.goButtonClicked();
                }
                else {
                    switch (res.ErrorCode) {

                        case "ERR-LUCTL-DRCCLU1":
                            this.growlBox.addGrowl("error", "User Id is missing.");
                            break;

                        case "ERR-LUBL-SRVD1":
                            this.growlBox.addGrowl("error", "Invalid Land Use Id.");
                            break;

                        case "ERR-LUBL-SRVD2":
                            this.growlBox.addGrowl("error", "A published RCCLU association cannot be deleted.");
                            break;

                        default:
                            this.growlBox.addGrowl("error", this.cpdFormatters.formatError(res));
                    }

                    this.markGridAsLoading(false);
                }

            })
            .catch(err => {
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
                this.markGridAsLoading(false);
            })
    }


    //==================================
    // _filterLandUses
    //==================================
    _filterLandUses(landUses) {
        //Cut out the unused land uses
        let filteredAllLandUses = landUses.filter(lu => {
            switch (lu.land_use_code.toLowerCase()) {
                case "pr":  //protected
                case "kw":  //undetermined
                    break;
                default:
                    return lu;
            }
        });
        return filteredAllLandUses;
    }

    //=======================================
    // flattenRCC_DTO
    //=======================================
    // New DTO format for RCC data is bundled into objects.  The grid cannot read nested properties.  
    // So, we'll just flatten the response form the server back to the old format
    flattenRCC_DTO(dto) {

        if (dto.length > 0) {
            this._resourceComponentName = dto[0].component.resource_concern_component_display;
        }

        let arrOut = [];

        for (let i = 0; i < dto.length; i++) {

            let curRow = dto[i];

            //Add any associated land uses
            if (curRow.land_uses) {
                for (let j = 0; j < curRow.land_uses.length; j++) {
                    
                    let curLandUse = curRow.land_uses[j].landuse;
                    let curRcclu = curRow.land_uses[j].rcclu;
                
                    let flatRow = {
                        land_use_id: curLandUse.land_use_id,
                        land_use_display: curLandUse.land_use_display,
                        start_date: curRcclu.start_date,
                        end_date: curRcclu.end_date,
                        publish: curRcclu.publish,
                        resource_concern_component_land_use_id: curRcclu.resource_concern_component_land_use_id
                    }

                    arrOut.push(flatRow);

                }
            }

        }

        console.log("[{0}:flattenRCC_DTO()]:".format(this._componentName), arrOut);

        return arrOut;

    }

    //=======================================
    // Get Fiscal Year Date Range
    //=======================================
    getFiscalYearDateRange(fnOnComplete, fnOnError) {

        this.webServices.Get({
            apiPath: "/fiscalyear/getFiscalYearDates",
            args: {
                fiscalYear: this._selectedFY
            }
        })
            .then(res => {
                console.log("[{0}:fiscalyear():getFiscalYearDates()] - res:".format(this._componentName), res);
                if (this.helpers.isFunction(fnOnComplete)) { fnOnComplete(res.data.DTO); }
            })
            .catch(err => {
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
                if (fnOnError) { fnOnError(); }
            });
    }

    //=======================================
    // initLandUseGrid
    //======================================
    initLandUseGrid(fnOnComplete) {

        this.markGridAsLoading(true);

        this.loadComponentLandUses(this._selectedFY, this._componentId, (dto) => {

            //Update the grid to show the land uses
            if (this.mainGrid) {
                this.mainGrid.SetRows(dto);
            }
            else {
                this._mainGridSettings.rows = dto;
            }
            this.markGridAsLoading(false);

            if (this.helpers.isFunction(fnOnComplete)) { fnOnComplete(); }
        });
    }

    //=======================================
    // initFiscalYears
    //======================================
    //  Loads and populates the fy list
    initFiscalYears(fnOnComplete) {

        this.webServices.Get({ apiPath: "/resource/getFiscalYearRangeForAllResources" })
            .then(res => {

                console.log("[{0}:initFiscalYears():getFiscalYearRangeForAllResources()] - res:".format(this._componentName), res);
                let dto = res.data.DTO;

                //Build FY list
                var curFY = this.helpers.getFY();
                this._fiscalYears = [];
                for (let i = dto.minFiscalYear; i <= dto.maxFiscalYear; i++) {
                    this._fiscalYears.push(i);
                    
                }

                //Select the current FY 
                this._selectedFY = this._fiscalYears.find(x => x == this._selectedFY);

                //Get fiscal year date range
                this.getFiscalYearDateRange((dateRange) => {
                    this._fiscalStart = dateRange.start;
                    this._fiscalEnd = dateRange.end;
                });

                if (this.helpers.isFunction(fnOnComplete)) { fnOnComplete(); }

            })
            .catch(err => {
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
            });
    };

    //=======================================
    // insertLandUse
    //=======================================
    insertLandUse() {

        //Do the deed
        this.webServices.Post("/landuse/insertRCCLU", this._insertLU)
            .then(res => {
                console.log("[{0}:landuse/insertRCCLU] - res:".format(this._componentName), res);

                if (res.Success) {

                    //Update the alerts & refresh grid
                    this.growlBox.addGrowl("success", "Land Use Saved");
                    this.goButtonClicked();
                }
                else {
                    switch (res.ErrorCode) {

                        case "ERR-LUCTL-IRCCLU1":
                            this.growlBox.addGrowl("error", "User Id is missing.");
                            break;

                        case "ERR-LUBL-SRVI1":
                            this.growlBox.addGrowl("error", "Invalid Land Use publish value.");
                            break;

                        case "ERR-LUBL-SRVI2":
                            this.growlBox.addGrowl("error", "Invalid Land Use.");
                            break;

                        case "ERR-LUBL-SRVI3":
                            this.growlBox.addGrowl("error", "Invalid Resource Concern Component.");
                            break;

                        case "ERR-LUBL-SRVI4":
                            this.growlBox.addGrowl("error", "Start and End Dates appear incorrect.");
                            break;

                        case "ERR-LUBL-SRVI5":
                            this.growlBox.addGrowl("error", "This component is already associated with the indicated landuse for the given date range.");
                            break;

                        default:
                            this.growlBox.addGrowl("error", this.cpdFormatters.formatError(res));
                    }

                    this.markGridAsLoading(false);
                }


            })
            .catch(err => {
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
                this.markGridAsLoading(false);
            })
    }

    //=======================================
    // loadActionLinks
    //=======================================
    loadActionLinks() {

        //Load the form fields
        let actions = [];
        actions.push(new FormAction("act_back_to_component", "Back to Component", true, "Return to Component Screen"));
        actions.push(new FormAction("act_delete_land_use", "Delete Land Use", true, "Delete selected, unpublished Land Use"));
        actions.push(new FormAction("act_new_land_use", "New Land Use"));
        actions.push(new FormAction("act_edit_land_use", "Edit Land Use"));

        console.log("[{0}:ngOnInit()] - actionLinks:".format(this._componentName, this._formName), actions);

        //Tell the shared navBoxCommService what the current actions are (will update the navBox actions)
        this.casNavBoxService.Actions = actions;
        this.casNavBoxService.ActionsLoading = true;

    }

    //=======================================
    // loadAllLandUses
    //=======================================
    loadAllLandUses(fnOnComplete, fnOnError) {

        this.webServices.GetCached({
            apiPath: "/landuse/getLandUses",
            clone: true,
            args: {
                fy: this._selectedFY
            }
        })
            .then(res => {
                console.log("[{0}:loadAllLandUses()] - res:".format(this._componentName), res);

                // Create land use DDL list with blank entry
                let allLandUses = [{ land_use_id: -1, land_use_code: "", land_use_name: "", land_use_display: "", land_use_description: "" }].concat(res.data.DTO);

                this._allLandUses = this._filterLandUses(allLandUses);

                if (this.helpers.isFunction(fnOnComplete)) { fnOnComplete(); }
            })
            .catch(err => {
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
            });

    }

    //=======================================
    // loadComponentLandUses
    //=======================================
    loadComponentLandUses(fy, componentId, fnOnComplete, fnOnError) {

        this.webServices.Get({
            apiPath: "/resource/getResourceConcernComponents2",
            args: {
                fiscalYear: fy,
                resourceConcernId: null,
                resourceConcernComponentId: componentId,
                publishedOnly: false,
                filterLandUseByFY: true
            }
        })
            .then(res => {
                console.log("[{0}:loadComponentLandUses()] - res:".format(this._componentName), res);
                if (this.helpers.isFunction(fnOnComplete)) { fnOnComplete(this.flattenRCC_DTO(res.data.DTO)); }
            })
            .catch(err => {
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
            });
    }

    //=======================================
    // saveLandUse
    //=======================================
    saveLandUse() {

        //Run validation independently, as it modified the screen by setting validation error messages
        let isValid = this.casValidate.isAllValid(true, "popupLandUseFields");

        //Have there been any changes?
        if (!this._popupDirty) {
            alert("No changes detected.");
            return;
        }

        //Is the data valid
        if (!isValid) {
            alert("Please ensure that all field are valid and complete.");
            return;
        }

        //Notify saving to the user
        this.markGridAsLoading(true);
        this.growlBox.addGrowl("info", "Saving Land Use...");

        //Close the dialog
        this.popLandUse.Close();

        //Populate dates from ngbDateParser
        this._startDate = this._startDate ? new Date(this._startDate).toISOString() : null;
        this._endDate = this._endDate ? new Date(this._endDate).toISOString() : null;

        if (this._newLandUse) {
            this._insertLU = {
                resource_concern_component_id: this._componentId,
                land_use_id: this._selectedLandUses_LandUsePopup.land_use_id,
                start_date: this._startDate,
                end_date: this._endDate,
                publish: this._publish ? 'Y' : 'N'
            }
            this.insertLandUse();
        }
        else {
            this._updateLU = {
                resource_concern_component_land_use_id: this._resourceConcernComponentLandUseId,
                start_date: this._startDate,
                end_date: this._endDate,
                publish: this._publish ? 'Y' : 'N'
            }
            this.updateLandUse();
        }

    }

    //=======================================
    // updateLandUse
    //=======================================
    updateLandUse() {

        //Do the deed
        this.webServices.Post("/landuse/updateRCCLU", this._updateLU)
            .then(res => {
                console.log("[{0}:landuse/updateRCCLU] - res:".format(this._componentName), res);

                if (res.Success) {
                    //Update the alerts & refresh grid
                    this.growlBox.addGrowl("success", "Land Use Saved");
                    this.goButtonClicked();
                }
                else {
                    switch (res.ErrorCode) {

                        case "ERR-LUCTL-URCCLU1":
                            this.growlBox.addGrowl("error", "User Id is missing.");
                            break;

                        case "ERR-LUBL-SRVU1":
                            this.growlBox.addGrowl("error", "Invalid Land Use.");
                            break;

                        case "ERR-LUBL-SRVU1A":
                            this.growlBox.addGrowl("error", "Start and end dates appear incorrect.");
                            break;

                        case "ERR-LUBL-SRVU2":
                            this.growlBox.addGrowl("error", "Invalid Land Use.");
                            break;

                        case "ERR-LUBL-SRVU3":
                            this.growlBox.addGrowl("error", "This component is already associated with the indicated landuse for the given date range.");
                            break;

                        case "ERR-LUBL-SRVU4":
                            this.growlBox.addGrowl("error", "Cannot unpublish a published Land Use.");
                            break;

                        case "ERR-LUBL-SRVU5A":
                            this.growlBox.addGrowl("error", "Cannot change the start date on a published rcclu where the start date has already passed.");
                            break;

                        case "ERR-LUBL-SRVU5B":
                            this.growlBox.addGrowl("error", "Cannot change the start date on a published rcclu to a date in the past");
                            break;

                        default:
                            this.growlBox.addGrowl("error", this.cpdFormatters.formatError(res));
                    }

                    this.markGridAsLoading(false);
                }

            })
            .catch(err => {
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
                this.markGridAsLoading(false);
            })
    }

    //=======================================
    // markGridAsLoading
    //=======================================
    markGridAsLoading(isLoading) {

        if (this.mainGrid) {
            this.mainGrid.MarkAsLoading(isLoading);
        }
        else {
            this._mainGridSettings.loading = isLoading;
        }
    }

    //=======================================
    // resetSelectedFiscalYear
    //=======================================
    resetSelectedFiscalYear() {
        // Reset selected fiscal year.
        this._selectedFY = this.helpers.getFY();
    }

    //=======================================
    // sendJawsNotification
    //=======================================
    sendJawsNotification(message) {
        $("#accLivePolite").empty();
        $("#accLivePolite").append(`<p>${message}</p>`);
    }

    // DEBUGGING
    //-------------------------------------------------------------------------------------------------------------------------
    //=======================================
    // debugEntryClicked
    //=======================================
    debugEntryClicked(entry) {

        console.log("[{0}:debugEntryClicked]".format(this._componentName));
        console.log("    ", entry);

    };

};
